import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { Mail, Phone, MapPin, Linkedin, Instagram, Facebook } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-surface border-t border-border">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Logo size="default" />
            <p className="mt-6 text-text-muted font-body text-sm leading-relaxed">
              Specialist Insurance Repair & Building Construction Partner. 100% Black-Owned, Level 1 B-BBEE contributor serving the Western Cape and nationally.
            </p>
            <div className="flex gap-4 mt-6">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-linkedin"
                className="text-text-muted hover:text-primary transition-colors"
              >
                <Linkedin size={20} />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-instagram"
                className="text-text-muted hover:text-primary transition-colors"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-facebook"
                className="text-text-muted hover:text-primary transition-colors"
              >
                <Facebook size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <span className="overline">Quick Links</span>
            <ul className="mt-6 space-y-4">
              {['Home', 'About', 'Services', 'Projects', 'Contact'].map((item) => (
                <li key={item}>
                  <Link
                    to={item === 'Home' ? '/' : `/${item.toLowerCase()}`}
                    data-testid={`footer-link-${item.toLowerCase()}`}
                    className="text-text-muted hover:text-text-main transition-colors font-body text-sm"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <span className="overline">Services</span>
            <ul className="mt-6 space-y-4">
              {[
                'Roofing & Waterproofing',
                'Plumbing Services',
                'General Maintenance',
                'Building Construction',
                'Asbestos Removal',
              ].map((item) => (
                <li key={item}>
                  <Link
                    to="/services"
                    data-testid={`footer-service-${item.toLowerCase().replace(/\s+/g, '-')}`}
                    className="text-text-muted hover:text-text-main transition-colors font-body text-sm"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <span className="overline">Contact</span>
            <ul className="mt-6 space-y-4">
              <li>
                <a
                  href="mailto:info@MBConstruction.co.za"
                  data-testid="footer-email"
                  className="flex items-start gap-3 text-text-muted hover:text-text-main transition-colors font-body text-sm"
                >
                  <Mail size={18} className="mt-0.5 flex-shrink-0" />
                  info@MBConstruction.co.za
                </a>
              </li>
              <li>
                <a
                  href="tel:+27825697495"
                  data-testid="footer-phone"
                  className="flex items-start gap-3 text-text-muted hover:text-text-main transition-colors font-body text-sm"
                >
                  <Phone size={18} className="mt-0.5 flex-shrink-0" />
                  082 569 7495
                </a>
              </li>
              <li className="flex items-start gap-3 text-text-muted font-body text-sm">
                <MapPin size={18} className="mt-0.5 flex-shrink-0" />
                <span>
                  220 Main Road<br />
                  Claremont, Cape Town, 7708<br />
                  South Africa
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-text-muted font-mono text-xs">
            &copy; {currentYear} MB Construction. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link
              to="/privacy"
              data-testid="footer-privacy"
              className="text-text-muted hover:text-text-main transition-colors font-mono text-xs"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              data-testid="footer-terms"
              className="text-text-muted hover:text-text-main transition-colors font-mono text-xs"
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
